import type { Messages } from "@prop/i18n";
import type en from "../en/landing";

export default {
  brand: "Funded Lime",
  buy: "Empieza el challenge",
  nav: { programs: "Programas", execution: "Ejecución", docs: "Documentos", faq: "FAQ", cabinet: "Mi panel", signIn: "Iniciar sesión", start: "Abrir cuenta", language: "Idioma", menu: "Menú" },
  hero: {
    titleA: "Exprime",
    titleB: "el mercado",
    year: "(’26)",
    about: "(Nosotros)",
    aboutText: "Una mesa de prop trading simulada sobre datos de mercado reales. Cada orden toca el libro en vivo en cuanto llega y se ejecuta en 10–30 ms.",
    badge: "Política v{v}",
    avail1: "Ejecución en 10–30 ms",
    avail2: "sin latencia añadida",
    outNow: "Ya en vivo",
    outTitle: "Cripto 24/7",
    outTag: "[En vivo]",
    feed: "Feed del motor",
    markets: "Mercados",
    sources: "Datos de mercado en tiempo real · cripto · FX · índices",
    live: "En vivo desde el motor",
    title: "Prop trading sobre un motor real",
    lead: "Cada orden se ejecuta al instante contra el libro de órdenes en vivo, y cada ejecución guarda una foto del mercado. Cripto las 24 horas, FX y futuros CME.",
    primary: "Elige un programa",
    secondary: "Crea tu cuenta",
    btc: "Última operación BTC",
    latency: "Latencia añadida, p50",
    fills: "Ejecuciones, 7 días",
    policy: "Política de ejecución",
    tape: "Últimas operaciones",
    ms: "{v} ms",
  },
  bar: { since: "Desde", year: "2026", scroll: "Desliza hacia abajo", live: "En vivo en el libro" },
  statement: {
    text: "No vendemos sueños. Vendemos una ejecución justa: cada orden toca el libro en vivo, cada ejecución guarda su comprobante y las reglas que compras quedan congeladas por su hash.",
    sub: "Cuentas simuladas sobre datos de mercado reales.",
    subMuted: "Hecho para traders que saben leer la cinta.",
  },
  slogans: {
    s1: "Es momento de empezar",
    s2: "Es momento de cambiar",
    s3: "Opera el plan, no la esperanza",
    s4: "La disciplina es libertad",
    s5: "Riesgo pequeño, visión larga",
    s6: "Gánate tu capital",
  },
  quotes: {
    money: { text: "El dinero sigue a la disciplina. Nunca al revés.", by: "— Regla de la mesa" },
    start: { text: "Todo trader funded fue un principiante que no se rindió.", by: "— Regla de la mesa" },
  },
  board: {
    title: "La ejecución, a la vista",
    lead: "Datos agregados de la foto del mercado que el motor guarda con cada ejecución de los últimos 7 días. Nada se elige ni se edita.",
    live: "En vivo",
    updated: "Actualizado {time}",
    fills: "Ejecuciones en 7 días",
    accounts: "cuentas operando",
    latency: "Latencia añadida, p50 / p99",
    quoteAge: "Antigüedad de la cotización al ejecutar, p50 / p99",
    walked: "Ejecuciones que recorrieron el libro visible",
    policy: "Política de ejecución",
    lastFill: "Última ejecución {time}",
    ms: "{a} / {b} ms",
    withheld: "Aún hay muy pocas ejecuciones en el periodo para publicar cifras.",
    loading: "Cargando…",
    receipt: "Cada ejecución guarda su comprobante",
    receiptLead: "“Por qué aquí” en cualquier ejecución: el libro que tocó, el precio de marca, la última operación, la antigüedad de la cotización, la latencia, el modelo de ejecución y la versión de la política.",
  },
  spec: {
    title: "Elige tu evaluación",
    lead: "Todos los parámetros antes de pagar. Las reglas que compras quedan congeladas e identificadas por su hash.",
    market: "Mercado",
    markets: { crypto: "Perpetuos cripto", fx: "FX y metales", futures: "Futuros CME" },
    desc: {
      crypto: "Perpetuos de BTC, ETH y SOL con datos de mercado en vivo. El libro nunca cierra.",
      fx: "EUR/USD, GBP/USD, USD/JPY y oro. El día termina a las 17:00 de Nueva York.",
      futures: "ES, NQ, CL y GC en la sesión de CME.",
    },
    steps: "Evaluación",
    step1: "1 fase",
    step2: "2 fases",
    size: "Tamaño de la cuenta",
    fee: "Precio de la evaluación",
    target: "Objetivo de ganancia",
    dll: "Límite de pérdida diaria",
    ml: "Pérdida máxima",
    days: "Días mín. de trading",
    split: "Reparto de ganancias",
    dayEnds: "Fin del día de trading",
    version: "Versión de reglas",
    oneTime: "pago único",
    perMonth: "/ mes",
    yourTime: "{time} tu hora",
    select: "Empieza con {size}",
    footnote: "Precios de lanzamiento. Una nueva versión de reglas solo aplica a compras nuevas.",
    none: "Todavía no hay programa para esta combinación.",
  },
  platform: {
    title: "Una terminal hecha para esta mesa",
    lead: "Gráfico, libro de órdenes, operaciones recientes y un ticket que calcula el tamaño de la orden según tu riesgo. Con datos de mercado en vivo.",
    f1: { t: "Libro y cinta en vivo", d: "La profundidad y cada operación en el instante en que ocurre." },
    f2: { t: "Tamaño según el riesgo", d: "Fija el riesgo en dólares; el ticket hace el resto." },
    f3: { t: "SL y TP con la entrada", d: "El take profit y el stop loss entran junto con la orden." },
    f4: { t: "“Por qué aquí”", d: "El mercado en el momento exacto de cada ejecución." },
    caption: "La terminal con datos de mercado en vivo.",
  },
  how: {
    title: "De la evaluación al payout",
    s1: { line: "Elige un programa", note: "Cripto, FX o futuros CME. Un precio y un reglamento, congelados al comprar." },
    s2: { line: "Opera contra el libro en vivo", note: "Precios y profundidad reales; una orden de mercado recorre el libro." },
    s3: { line: "Alcanza el objetivo sin romper reglas", note: "La pérdida diaria y la máxima se verifican en cada tick, sobre el equity." },
    s4: { line: "Recibe hasta el 90 %", note: "Tras la verificación, a una billetera revisada, con la aprobación de dos personas." },
  },
  docs: {
    title: "Lee antes de operar",
    lead: "Lo que rige tu cuenta está por escrito, versionado y es público.",
    execution: { name: "Política de ejecución", meta: "v1.3 · ejecución contra todo el libro, comisión 0.75 % + 0.25 % por apalancamiento, x1–x30" },
    rules: { name: "Reglas del programa", meta: "Versionadas · SHA-256 por versión" },
    risk: { name: "Divulgación de riesgos", meta: "Trading simulado, sin acceso al mercado real" },
    terms: { name: "Términos y condiciones", meta: "Precios de evaluación, fase funded, payouts, KYC" },
    payouts: { name: "Política de payouts", meta: "Cuándo y cómo paga una cuenta funded" },
    refunds: { name: "Pagos y reembolsos", meta: "Pagos en cripto, reembolso antes de la primera operación" },
    prohibited: { name: "Prácticas prohibidas", meta: "Cobertura, multicuentas, copy trading, arbitraje" },
    privacy: { name: "Privacidad y cookies", meta: "Qué guardamos y por qué; solo cookies necesarias" },
    open: "Abrir",
  },
  faq: {
    title: "Preguntas",
    real: { q: "¿Es dinero real?", a: "El trading es simulado: las cuentas son virtuales y nuestro motor ejecuta las órdenes con datos de mercado reales. La tarifa que pagas es real, y también lo son los payouts de las cuentas funded: se pagan con fondos propios de la empresa según las reglas del programa." },
    fills: { q: "¿Cómo se ejecutan mis órdenes?", a: "Según una política de ejecución publicada (v1.3): sin latencia añadida — la orden toca el libro en vivo al llegar y se ejecuta en 10–30 ms. Una orden de mercado barre todo el libro: solo tiene disponible una quinta parte del tamaño mostrado en cada nivel, y el resto se ejecuta más allá del libro a un precio cada vez peor, con un spread más amplio que la cotización bruta. Así, las órdenes grandes pagan un deslizamiento real y el spread no se puede explotar. Comisiones: 0.75 % del nocional por lado más 0.25 % por apalancamiento; apalancamiento x1–x30, a tu elección. Abre “Por qué aquí” en cualquier ejecución." },
    day: { q: "¿Cuándo termina mi día de trading?", a: "Lo indica cada programa: 00:00 UTC en cripto, 17:00 de Nueva York en FX y la sesión de CME en futuros. La tarjeta del programa lo muestra en tu hora local." },
    rules: { q: "¿Pueden cambiar las reglas después de comprar?", a: "No. Tu cuenta se queda en la versión del programa que compraste, identificada por su hash. Una nueva versión solo aplica a compras nuevas." },
    feed: { q: "¿Y si falla el feed de datos?", a: "Un instrumento degradado nunca hace que una cuenta infrinja una regla. La decisión espera a que el feed vuelva a estar en vivo, y un pico breve de precio se filtra." },
    payouts: { q: "¿Cómo funcionan los payouts?", a: "Con la cuenta funded y la verificación hecha, solicitas un payout a una billetera que pasó el control de sanciones. Una persona lo prepara y otra lo aprueba." },
  },
  cta: {
    title: "Es momento de empezar",
    lead: "Elige un programa, lee cada regla y abre tu cuenta en minutos.",
    primary: "Elige un programa",
    secondary: "Crea tu cuenta",
  },
  pics: {
    engine: "Representación del núcleo del motor de ejecución",
    terminal: "La terminal: gráfico de BTC en vivo, libro de órdenes en vivo, operaciones recientes y ticket de orden",
    fill: "Una ejecución con su foto del mercado: modelo, latencia, antigüedad de la cotización, precio de marca, última operación y el libro",
  },
  footer: {
    risk: "Divulgación de riesgos. Todas las cuentas son simuladas; ninguna orden llega a un mercado real. Los resultados de una evaluación no predicen resultados en trading real. Los payouts de las cuentas funded se pagan con fondos propios de la empresa según las reglas del programa.",
    note: "Pago en cripto. La cuenta se abre en cuanto se confirma el pago.",
    top: "Volver arriba",
    contact: "hello@fundedlime.com",
    credits: "Gráficos: nuestro propio motor · datos de mercado: feeds de exchanges en tiempo real · imágenes: generadas",
    year: "2026",
  },
} satisfies Messages<typeof en>;
